import { userdata } from "./table_typing"

export interface tableState {
    model:{
            user:userdata[],
        }
    view:{
        loaded: boolean, 
        autorefresh: boolean,
    }
}

export const tableInitialState = {
    model:{
        user: [
        {        ip: "0.0.0.0",
                uuid: "0",
                severity0: 0,
                severity1: 0,
                severity2: 0,
                severity3: 0,
                severity4: 0,
                severity5: 0,
                severity6: 0,
                severity7: 0,
                severity8: 0,
                severity9: 0,
                severity10: 0,}
        ]
        }
        ,
        view:{
            loaded: false,
            autorefresh: false,
        }
    }


export function deepCopyTableThingyState(toCopy:tableState):tableState{
    return {
        model:{
            user:toCopy.model.user.map((user) =>
            {
                return {
                    ...user,
                }
            })
        },
        view:{
            loaded:toCopy.view.loaded,
            autorefresh:toCopy.view.autorefresh
        }
    }
    
}